import React from 'react';
import '../style.css';
import {Form,Button,Container,Row,Col,Navbar,Nav,NavDropdown,FormControl,label,input,h2,h3,h4,h5} from 'react-bootstrap';
import styled from 'styled-components';
import '../assets/styles/sb-admin-2.css';
import '../assets/styles/sb-admin-2.min.css';
import DataGrid from '../Components/Misc/DataGrid';
import waitimage from '../assets/images/720.gif';
const FormHeader=styled.p`
   
    margin-bottom: 1rem;
    // background-color: white;
    font-weight: bold;
    text-align: center;
    font-size:50px;
    color:rgb(12 16 167);
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    `;

class ExceptionReport extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            tableData:[],
            fileName:'',
            seasonData:[],
            ready: false,
            columnstoview:['Format','Zone','State','City','TM','Aom','WeekNo','Store','Image'] ,
             startdate:null,
            enddate:null
                    }
                     }

  handleSubTableChange=(event)=>{
   
      this.setState({[event.target.name]: event.target.value});
  }
                     componentDidMount() { 
                this.initialize();
                       
                        }

                        initialize(){
                          var stdate=this.state.startdate;
        var enddate=this.state.enddate;
        if(stdate==null||enddate==null){
           enddate = new Date();
           stdate = new Date(enddate);
          stdate.setMonth(enddate.getMonth() - 1);
          var stmonth=(stdate.getMonth()+1);
          var endmonth=(enddate.getMonth()+1);
          var stdt=stdate.getDate();
          var enddt=enddate.getDate();
          stdate=stdate.getFullYear()+'-'+(stmonth<10?'0'+stmonth:stmonth)+'-'+(stdt<10?'0'+stdt:stdt);
          enddate=enddate.getFullYear()+'-'+(endmonth<10?'0'+endmonth:endmonth)+'-'+(enddt<10?'0'+enddt:enddt);
         
        }
                        let url = process.env.REACT_APP_DEBUG_URL+'/api/getexceptionreport?StartDate='+stdate+'&Enddate='+enddate;
                             let token =localStorage.getItem("UserToken");
                             const requestOptions = {
                              method: 'GET',
                              headers: { 'Content-Type': 'application/json','Authorization': 'Bearer '+token }
                             
                          };
                          fetch(url, requestOptions)
                          .then(res => res.json())
                          .then(result => {
                           console.log('data=',result.data);
                           this.setState({tableData:result.data,startdate:stdate,enddate:enddate,ready:true})
                          })
                                 
                        }
                        seteditid=(editid)=>{}
                        render() { 
                            let projectname='TL Image Portal';
                            const WorkArea = styled.div`
                            background: white;
                            left:250;
                            height: 100vh;
                            display: flex;
                            
                          `;
                    if(this.state.ready==false)
                     
                        return(<div className='waitdiv'><center><img className="waitimage" src={waitimage} /></center></div>)
                                      else
                                      return(
                                        <div id="content-wrapper" className="d-flex flex-column">            
                                        <div id="content" className='containerh'>              
                                          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow" >              
                                           <div style={{fontSize:'50px',color:'rgb(12 16 167)'}}>{projectname}</div>               
                                          </nav> 
                                          <FormHeader>Exception Report</FormHeader>
                                           <div className='daterange' style={{textAlign:'right'}}>
                    <label>Start Date</label>
                    <input  type="date" id='startdate' name='startdate' onChange={this.handleSubTableChange} style={{marginLeft:'10px',marginRight:'10px'}} value={this.state.startdate}></input>
                     <label>End Date</label>
                    <input  type="date" id='enddate' name='enddate' onChange={this.handleSubTableChange} value={this.state.enddate} style={{marginLeft:'10px'}} ></input>
                    <input type='button' value='submit' style={{marginLeft:'20px'}} onClick={()=>{
                      this.setState({ready:false},()=>{ this.initialize();})
      }}/>
                </div>
                                         <div className='datatable2' >
                                           <DataGrid tableid={4} tablename={'ImageMaster'} rowsarray={this.state.tableData} advancefilter={1}  seteditid={this.seteditid } columns={this.state.columnstoview} showeditbutton={false}/> 
                                             </div>
                                             <footer className="sticky-footer bg-white">
        <div className="container my-auto" style={{backgroundColor:'#fff'}}>
          <div className="copyright text-center my-auto">
            <span style={{fontSize:'25px'}}><a href='https://thinkmaster.technology' target='_blank'>Developed & Maintain by Thinkmaster Technology</a></span>
          </div>
        </div>
      </footer>
      </div></div>
                                      );

            }
        }export default ExceptionReport;